import React from 'react';
import Container from 'evcharging/components/Container';
import Spacer from 'evcharging/components/Spacer';
import Responsible from 'evcharging/components/Responsible';
import Section from 'evcharging/containers/layout/Section';
import Title from 'evcharging/components/Title';
import NumberText from 'evcharging/containers/ocpp/NumberText';
import Desktop from 'evcharging/components/Desktop';
import Mobile from 'evcharging/components/Mobile';
import howItWorks from 'evcharging/assets/occp/howItWorks.png';
import Box from 'evcharging/components/Box';
import Baget from 'evcharging/components/Baget';
import Paragraph from 'evcharging/components/Paragraph';
import { CONTACT_US_ANCHOR } from 'evcharging/app/seo/urls';
import LinkButton from 'evcharging/components/LinkButton';
import useI18n from 'evcharging/hooks/useI18n';
import Image from 'next/image';

const Advantages = () => {
  const { t } = useI18n();
  const items = [
    {
      num: '01',
      title: t('ocpp.freedom1.title'),
      text: t('ocpp.freedom1.text'),
    },
    {
      num: '02',
      title: t('ocpp.freedom2.title'),
      text: t('ocpp.freedom2.text'),
    },
    {
      num: '03',
      title: t('ocpp.freedom3.title'),
      text: t('ocpp.freedom3.text'),
    },
  ];

  return (
    <Section>
      <Container>
        <Desktop>
          <Title variant={'h2'} center>
            {t('ocpp.freedom.title')}
          </Title>
        </Desktop>
        <Mobile>
          <Title variant={'h2'}>{t('ocpp.freedom.title')}</Title>
        </Mobile>
        <Spacer value={42} />
        <Responsible fractions={[31, 31, 31]}>
          {items.map((item) => (
            <NumberText {...item} key={item.num} />
          ))}
        </Responsible>
        <Spacer value={150} mobile={100} />
        <Responsible fractions={[48, 48]} maxWidth={1000} margin={'0 auto'}>
          <Image src={howItWorks} alt={t('ocpp.how.title')} width={495} height={378} />
          <Box>
            <Baget>{t('ocpp.how.label')}</Baget>
            <Spacer value={16} />
            <Title variant={'h2'}>{t('ocpp.how.title')}</Title>
            <Spacer value={12} />
            <Paragraph color={'middle'}>{t('ocpp.how.body')}</Paragraph>
            <Spacer value={24} />
            <LinkButton href={CONTACT_US_ANCHOR}>{t('ocpp.schedule')}</LinkButton>
          </Box>
        </Responsible>
      </Container>
    </Section>
  );
};

export default Advantages;
